import './style.scss';
import Stack from './stack.js';

export default Stack;